module.exports = __webpack_public_path__ + "media/images/mein-einkauf/mein-einkauf-ch-logo-a4d586121681a4e5a8c526e41fca9016.png";